// Adapter: turn the app's existing pure validators (utils/validators.js) into
// react-hook-form `validate` rules. A rhf rule returns `true` when the value is
// valid, or the message string when it is invalid — so the message travels with
// the rule instead of living in a separate rrf `<Errors messages={...}>` map.
//
// The validators in utils/validators.js are factories: calling one with no
// callback (e.g. `validators.required()`, `validators.minLength(5)`) yields a
// pure `value => truthy|falsy` predicate, which drops straight in here.
//
// Usage in a form:
//   import validators from 'utils/validators';
//   import { toRule } from 'forms/rhf';
//   register('email', { validate: {
//     required: toRule(validators.required(), 'Email is required'),
//     format: toRule(validators.isEmail(), 'Enter a valid email address'),
//   }});
export const toRule = (predicate, message) => value => (predicate(value) ? true : message);

export default toRule;
